import axios from 'axios';

const API_URL = 'https://dailyreportsapi.winggs.in/api/projects';
// const API_URL = 'http://localhost:5000/api/projects'; // Use this for local development

const projectService = {
  // Get all projects
  getAllProjects: async () => {
    const response = await axios.get(API_URL);
    return response.data;
  },
  
  // Get projects assigned to the current user
  getMyProjects: async () => {
    const response = await axios.get(`${API_URL}/me`);
    return response.data;
  },

  // Get projects assigned to a specific user
  getProjectsByUserId: async (userId) => {
    if (!userId) return [];
    try {
      console.log(`Fetching projects for user ID: ${userId}`);
      // Fix endpoint path - remove duplicate 'projects' segment
      const response = await axios.get(`${API_URL}/user/${userId}`);
      console.log('Projects retrieved:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching user projects:', error.response?.data || error.message);
      return [];
    }
  },

  // Get project by ID
  getProjectById: async (id) => {
    const response = await axios.get(`${API_URL}/${id}`);
    return response.data;
  },

  // Create a new project (admin only)
  createProject: async (projectData) => {
    const response = await axios.post(API_URL, projectData);
    return response.data;
  },

  // Update a project (admin only)
  updateProject: async (id, projectData) => {
    const response = await axios.put(`${API_URL}/${id}`, projectData);
    return response.data;
  },

  // Delete a project (admin only)
  deleteProject: async (id) => {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  }
};

export default projectService;
